export default __webpack_public_path__ + "static/media/LAS0500.34I-43709_-26103_0.90d1bdaa.jpg";